import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PanelService } from 'src/app/modules/shared/services/api/panel.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/modules/shared/services/snack-bar.service';
import { Subscription } from 'rxjs';
import { StateService } from 'src/app/modules/shared/services/storage/state.service';
import { WalletPaymentDialogComponent } from '../wallet-payment-dialog/wallet-payment-dialog.component';
import { WalletBalanceService } from 'src/app/modules/shared/services/resolver/wallet-balance.service';
import { ProfileResolverService } from 'src/app/modules/shared/services/resolver/profile-resolver.service';
import { GoogleTagManagerService } from 'src/app/modules/shared/services/google-tag-manager.service';
import { Profile } from 'src/app/modules/shared/models/profile.mode';
import { Location } from '@angular/common';
import { PaymentService } from 'src/app/modules/shared/services/payment.service';
import { BinanceService } from 'src/app/modules/shared/services/binance/binance.service';
import {
  GATEWAY_TYPE,
  GatewayDetail,
  GatewayGroup
} from 'src/app/modules/shared/models/gateway.model';

@Component({
  selector: 'app-charge-wallet-sheet',
  templateUrl: './charge-wallet-sheet.component.html',
  styleUrls: ['./charge-wallet-sheet.component.scss']
})
export class ChargeWalletSheetComponent implements OnInit {
  paymentMethodMode = 'wallet';
  orderForm: FormGroup;
  gatewayGroups: GatewayGroup[];
  walletId: any;
  isLoadSubmitButton: boolean = true;
  redirect_url: any;
  checkBitPay: boolean = false;
  subscriptions: Subscription[] = [];
  orderData: any;
  profile: Profile;
  payableAmount: any;
  processingFee: number;
  payableCurrency: any;
  customerCardList: any;
  selectedSuggestedAmount: number;
  @ViewChild('customerCardListDialog') customerCardListDialog: any;
  @ViewChild('verify') verify: any;
  constructor(
    private panelService: PanelService,
    public dialog: MatDialog,
    private router: Router,
    private snackBarService: SnackBarService,
    private binanceService: BinanceService,
    private stateService: StateService,
    private walletBalance: WalletBalanceService,
    private paymentService: PaymentService,
    private googleTagManagerService: GoogleTagManagerService,
    private profileResolver: ProfileResolverService,
    private locationService: Location
  ) {}

  ngOnInit(): void {
    this.profileResolver.permissionInitInfo.subscribe((data) => {
      this.profile = data;
    });
    this.initOrderForm();
    this.getGatewayGroups();
    this.onFormChange();
  }

  initOrderForm() {
    this.orderForm = new FormGroup({
      amount: new FormControl('', [Validators.required, Validators.min(0.1)]),
      gateway: new FormControl('', Validators.required)
    });
  }

  getGatewayGroups() {
    this.panelService.getGatewayGroups().subscribe((groups) => {
      this.gatewayGroups = [...groups];
    });
  }

  onSubmitOrderForm() {
    this.submitPayment();
  }

  hiPinPayment(order) {
    let title = this.orderForm.get('gateway').value.title;
    const dialogRef = this.dialog.open(WalletPaymentDialogComponent, {
      minWidth: '300px',
      maxWidth: '500px',
      panelClass: 'full-with-dialog',
      data: { order, title }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        this.router.navigate(['/wallet']);
        this.stateService.setIsWalletReloaded(true);
        this.walletBalance.updateInfo();
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  onFormChange() {
    let orderFormSubscription = this.orderForm.valueChanges.subscribe(
      (value) => {
        this.orderForm
          .get('amount')
          .setValidators([Validators.required, Validators.min(0.1)]);
        this.orderForm.get('amount').updateValueAndValidity({ onlySelf: true });
        if (value.gateway.gateway_type == GATEWAY_TYPE.BITPAY) {
          if (value.amount < 1) {
            this.orderForm
              .get('amount')
              .setValidators([Validators.required, Validators.min(1)]);
            this.orderForm
              .get('amount')
              .updateValueAndValidity({ onlySelf: true });
            this.checkBitPay = false;
          } else if (value.amount >= 1) {
            this.checkBitPay = true;
          }
        }
        if (
          value.gateway.gateway_type == GATEWAY_TYPE.BITPAY &&
          value.amount < 1
        ) {
          this.orderForm
            .get('amount')
            .setValidators([Validators.required, Validators.min(1)]);
          this.orderForm
            .get('amount')
            .updateValueAndValidity({ onlySelf: true });
          this.checkBitPay = false;
        }
        if (
          value.gateway.gateway_type == GATEWAY_TYPE.BITPAY &&
          value.amount == 1
        ) {
          this.checkBitPay = true;
        }
        if (
          value.gateway.gateway_type != GATEWAY_TYPE.BITPAY &&
          value.amount >= 0.1
        ) {
          this.orderForm.get('amount').setErrors(undefined);
          this.checkBitPay = true;
        }

        if (
          this.orderForm.get('gateway').value &&
          this.orderForm.get('amount').value
        ) {
          this.payableAmount =
            (1 + Number(this.orderForm.get('gateway').value?.share) / 100) *
            Number(this.orderForm.get('amount').value);
          this.processingFee = this.paymentService.getProcessingFee({
            share: this.orderForm.get('gateway').value?.share,
            activationFee: 0,
            discount: 0,
            itemCount: 1,
            exchangeRate: 1,
            itemPrice: this.orderForm.get('amount').value
          });
          this.payableCurrency =
            this.orderForm.get('gateway').value?.currency_detail?.symbol;
        } else {
          this.processingFee = undefined;
          this.payableAmount = '';
          this.payableCurrency = '';
        }
      }
    );

    let gatewayFormControlSubscription = this.orderForm
      .get('gateway')
      .valueChanges.subscribe((val) => {
        this.googleTagManagerService.sendAnalytics('charge_wallet_method', {
          method: 'Gateway',
          gateway_name: val.title
        });
      });

    this.subscriptions.push(
      orderFormSubscription,
      gatewayFormControlSubscription
    );
  }

  submitPayment() {
    if (this.orderForm.get('gateway').invalid) {
      return;
    }

    let gateway = this.orderForm.get('gateway').value;

    if (gateway.gateway_type == GATEWAY_TYPE.PAYPAL) {
    } else {
      this.orderData = {
        amount: this.orderForm.get('amount').value,
        gateway: this.orderForm.get('gateway').value.id
      };
      if (
        this.orderForm.get('gateway').value.gateway_type != GATEWAY_TYPE.HIGIFT
      ) {
        this.orderData = {
          amount: this.orderForm.get('amount').value,
          gateway: this.orderForm.get('gateway').value.id,
          callback_url: `${window.location.origin}/payment`
        };
      }

      if (
        gateway.payment_method_type == 1 ||
        gateway.payment_method_type == 3
      ) {
        this.getCustomerCardsList(gateway);
        return;
      }

      this.panelService.chargeWallet(this.orderData).subscribe(
        (order) => {
          if (order?.status == -1) {
            this.snackBarService.showSnackBar(
              order?.status_display,
              'primary',
              2000
            );
            return;
          }

          if (
            order?.gateway_detail?.gateway_type == GATEWAY_TYPE.MARAL ||
            order?.gateway_detail?.gateway_type == GATEWAY_TYPE.BITPAY ||
            order?.gateway_detail?.gateway_type == GATEWAY_TYPE.NGENIUS ||
            order?.gateway_detail?.gateway_type == GATEWAY_TYPE.CRYPTO_GATEWAY
          ) {
            if (order?.payment_detail) {
              window.location.href = order?.payment_detail?.redirect_url;
            } else {
            }
          } else if (
            order?.gateway_detail?.gateway_type == GATEWAY_TYPE.HIGIFT
          ) {
            this.hiPinPayment(order);
          } else if (
            order?.gateway_detail?.gateway_type == GATEWAY_TYPE.EZPINPAYMENT
          ) {
            window.location.href = order?.redirect_url;
          } else if (
            order?.gateway_detail?.gateway_type ==
              GATEWAY_TYPE.PROVIDER_HOSTED_PAGE ||
            order?.gateway_detail?.gateway_type == GATEWAY_TYPE.BINANCE_PAY
          ) {
            let extra_data = order.extra_info;
            let payload = {
              certSn: extra_data['CertSn'],
              merchantId: `${extra_data['MerchantId']}`,
              timeStamp: extra_data['TimeStamp'],
              nonceStr: extra_data['NonceStr'],
              package: `prepay_id=${extra_data['PrepayId']}`,
              paySign: extra_data['PaySign']
            };
            if (this.binanceService.isBinance) {
              this.binanceService.requestBinancePayment(payload, '/wallet');
              return;
            } else {
              window.location.href = order?.redirect_url;
            }
          } else if (
            order?.gateway_detail?.gateway_type == GATEWAY_TYPE.GATEIO ||
            order?.gateway_detail?.gateway_type == GATEWAY_TYPE.KUCOIN
          ) {
            window.location.href = order?.redirect_url;
          } else if (
            order?.gateway_detail?.gateway_type ==
            GATEWAY_TYPE.CRYPTO_GATEWAY_INTERNAL
          ) {
            const refrenceCode = order.reference_code;
            if (refrenceCode) {
              this.router.navigateByUrl('/crypto/gateway/' + refrenceCode);
            }
          }
        },
        (error) => {}
      );
    }
  }

  getCustomerCardsList(gateway) {
    this.panelService.getCustomerCardsList(gateway.id).subscribe(
      (res) => {
        this.customerCardList = res;
        this.dialog.open(this.customerCardListDialog, { width: '500px' });
      },

      (error) => {
        this.snackBarService.showSnackBar(error.detail, 'primary', 2000);
      }
    );
  }

  addCard() {
    this.panelService
      .getCardLink(this.orderForm.get('gateway').value.id)
      .subscribe((res) => {
        if (res?.link) {
          this.dialog.closeAll();
          window.open(res?.link);
        }
      });
  }

  selectCard(card) {
    if (card) {
      this.dialog.open(this.verify, { minWidth: '400px', data: card });
    }
  }

  selectMethodId(methodId) {
    this.dialog.closeAll();
    this.orderData = {
      amount: this.orderForm.get('amount').value,
      gateway: this.orderForm.get('gateway').value.id,
      payment_method_id: methodId
    };
    if (
      this.orderForm.get('gateway').value.gateway_type != GATEWAY_TYPE.HIGIFT
    ) {
      this.orderData = {
        amount: this.orderForm.get('amount').value,
        gateway: this.orderForm.get('gateway').value.id,
        callback_url: `${window.location.origin}/payment`,
        payment_method_id: methodId
      };
    }

    this.panelService.chargeWallet(this.orderData).subscribe(
      (order) => {
        if (order?.status == -1) {
          this.snackBarService.showSnackBar(
            order?.status_display,
            'primary',
            2000
          );
          return;
        } else {
          this.walletBalance.updateInfo();
          this.router.navigate(['/wallet']);
          this.snackBarService.showSnackBar(
            'Payment completed successfully.',
            'primary',
            2000
          );
        }
      },
      (error) => {}
    );
  }

  onBack() {
    this.locationService.back();
  }

  onSuggestedAmountClick(amount, i) {
    this.selectedSuggestedAmount = i;
    this.orderForm.get('amount').patchValue(amount);
  }

  onGatewaySelected(gw: GatewayDetail) {
    this.orderForm.get('gateway').setValue(gw);
  }
}
